<template>
    <!-- 后台首页 -->
    <div  class="hp">
        <el-container>
            <!-- height="68px" -->
            <el-header>
                <div  class="header-top">
                    <!-- 顶部导航 -->
                    <div class="header-top-logo">
                        <img class="logoImg" src="@/assets/login/logo.png" />
                        <img class="titleLogo" src="@/assets/login/title.png" />
                    </div>
                    <div class="header-top-nav">

                        <!-- 用户 -->
                        <el-dropdown @command="handleCommand">
                            <div class="user">
                                <el-avatar :src="userInfo.avatar"></el-avatar>
                                <span>{{userInfo.real_name}}</span>
                            </div>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="Info" v-if="isAdmin==1">个人中心</el-dropdown-item>
                                <el-dropdown-item command="logOut">退出登录</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>

                    </div>
                </div>
            </el-header>
                <!-- 普通用户 -->
            <el-container v-if="isAdmin==0">
                <div class="kaifa">
                    <el-empty description="开发中，敬请期待"></el-empty>
                </div>
                <!-- <el-aside style="background-color: #fff"  class="menu" @scroll="syncContentScroll">
                    <el-menu :default-active="activeIndex" :unique-opened="true" text-color="#666"  @select="handleSelect">
                        <el-menu-item index="1">
                            <img v-if="activeIndex==1" class="logo-img" src="@/assets/home/txl.png" alt="">
                            <img v-else class="logo-img" src="@/assets/home/txlH.png" alt="">
                            <span slot="title" class="ziti">通讯录</span>
                        </el-menu-item>
                        <el-menu-item index="2" v-if="isAdmin==0">
                            <img v-if="activeIndex==2" class="logo-img" src="@/assets/home/gwgl.png" alt="">
                            <img v-else class="logo-img" src="@/assets/home/gwglH.png" alt="">
                            <span  class="ziti" slot="title">岗位管理</span>
                        </el-menu-item>
                        <el-menu-item index="5" v-if="isAdmin==1">
                            <img v-if="activeIndex==5" class="logo-img" src="@/assets/home/ygszH.png" alt="">
                            <img v-else class="logo-img" src="@/assets/home/ygszH.png" alt="">
                            <span  class="ziti" slot="title">一岗双责</span>
                        </el-menu-item>
                        <el-submenu index="3" v-else>
                            <template slot="title">
                                <img v-if="activeIndex==3" class="logo-img" src="@/assets/home/ygszH.png" alt="">
                                <img v-else class="logo-img" src="@/assets/home/ygszH.png" alt="">
                                <span>一岗双责</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item index="3-1">今日作业</el-menu-item>
                                <el-menu-item index="3-2">工作台</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                        <el-menu-item index="4">
                            <img v-if="activeIndex==4" class="logo-img" src="@/assets/home/xxzxH.png" alt="">
                            <img v-else class="logo-img" src="@/assets/home/xxzxH.png" alt="">
                            <span  class="ziti" slot="title">学习中心</span>
                        </el-menu-item>
                    </el-menu>
                </el-aside> -->
            </el-container>
            <el-container v-else>
                <!-- 普通用户 -->
                <el-aside v-if="isAdmin==0" style="background-color: #fff"  class="menu" @scroll="syncContentScroll">
                    <el-menu :default-active="activeIndex" :unique-opened="true" text-color="#666"  @select="handleSelect">
                        <el-menu-item index="1">
                            <img v-if="activeIndex==1" class="logo-img" src="@/assets/home/txl.png" alt="">
                            <img v-else class="logo-img" src="@/assets/home/txlH.png" alt="">
                            <span slot="title" class="ziti">通讯录</span>
                        </el-menu-item>
                        <el-menu-item index="2" v-if="isAdmin==0">
                            <img v-if="activeIndex==2" class="logo-img" src="@/assets/home/gwgl.png" alt="">
                            <img v-else class="logo-img" src="@/assets/home/gwglH.png" alt="">
                            <span  class="ziti" slot="title">岗位管理</span>
                        </el-menu-item>
                        <el-menu-item index="5" v-if="isAdmin==1">
                            <img v-if="activeIndex==5" class="logo-img" src="@/assets/home/ygszH.png" alt="">
                            <img v-else class="logo-img" src="@/assets/home/ygszH.png" alt="">
                            <span  class="ziti" slot="title">一岗双责</span>
                        </el-menu-item>
                        <el-submenu index="3" v-else>
                            <template slot="title">
                                <img v-if="activeIndex==3" class="logo-img" src="@/assets/home/ygszH.png" alt="">
                                <img v-else class="logo-img" src="@/assets/home/ygszH.png" alt="">
                                <span>一岗双责</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item index="3-1">今日作业</el-menu-item>
                                <el-menu-item index="3-2">工作台</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                        <el-menu-item index="4">
                            <img v-if="activeIndex==4" class="logo-img" src="@/assets/home/xxzxH.png" alt="">
                            <img v-else class="logo-img" src="@/assets/home/xxzxH.png" alt="">
                            <span  class="ziti" slot="title">学习中心</span>
                        </el-menu-item>
                    </el-menu>
                </el-aside>
                <!-- 专家 -->
                <el-aside v-else style="background-color: #fff"  class="menu" @scroll="syncContentScroll">
                    <el-menu :default-active="activeIndex" :unique-opened="true" text-color="#666"  @select="handleSelectExport">
                        <el-menu-item index="1">
                            <img v-if="activeIndex==1" class="logo-img" src="@/assets/exhome/gzt.png" alt="">
                            <img v-else class="logo-img" src="@/assets/exhome/gztH.png" alt="">
                            <span slot="title" class="ziti">工作台</span>
                        </el-menu-item>
                        <el-menu-item index="2">
                            <img v-if="activeIndex==2" class="logo-img" src="@/assets/exhome/yhgl.png" alt="">
                            <img v-else class="logo-img" src="@/assets/exhome/yhglH.png" alt="">
                            <span  class="ziti" slot="title">用户管理</span>
                        </el-menu-item>
                        <el-menu-item index="3">
                            <img v-if="activeIndex==3" class="logo-img" src="@/assets/exhome/bmgl.png" alt="">
                            <img v-else class="logo-img" src="@/assets/exhome/bmglH.png" alt="">
                            <span  class="ziti" slot="title">部门管理</span>
                        </el-menu-item>
                        <el-menu-item index="4">
                            <img v-if="activeIndex==4" class="logo-img" src="@/assets/exhome/gwgl.png" alt="">
                            <img v-else class="logo-img" src="@/assets/exhome/gwglH.png" alt="">
                            <span  class="ziti" slot="title">岗位管理</span>
                        </el-menu-item>
                        <el-menu-item index="5">
                            <img v-if="activeIndex==5" class="logo-img" src="@/assets/exhome/gzgl.png" alt="">
                            <img v-else class="logo-img" src="@/assets/exhome/gzglH.png" alt="">
                            <span  class="ziti" slot="title">工作管理</span>
                        </el-menu-item>
                        <el-submenu index="6">
                            <template slot="title">
                                <img class="logo-img" src="@/assets/exhome/fxcsH.png" alt="">
                                <span>风险措施</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item index="6-1">风险管理</el-menu-item>
                                <el-menu-item index="6-2">措施类型</el-menu-item>
                                <el-menu-item index="6-3">措施管理</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                        <el-menu-item index="7">
                            <img v-if="activeIndex==7" class="logo-img" src="@/assets/exhome/fxyj.png" alt="">
                            <img v-else class="logo-img" src="@/assets/exhome/fxyjH.png" alt="">
                            <span  class="ziti" slot="title">风险预警</span>
                        </el-menu-item>
                        <el-menu-item index="8">
                            <img v-if="activeIndex==8" class="logo-img" src="@/assets/exhome/zyzx.png" alt="">
                            <img v-else class="logo-img" src="@/assets/exhome/zyzxH.png" alt="">
                            <span  class="ziti" slot="title">重要资讯</span>
                        </el-menu-item>
                        <el-menu-item index="9">
                            <img v-if="activeIndex==9" class="logo-img" src="@/assets/exhome/jrzy.png" alt="">
                            <img v-else class="logo-img" src="@/assets/exhome/jrzyH.png" alt="">
                            <span  class="ziti" slot="title">今日作业</span>
                        </el-menu-item>
                        <el-submenu index="10">
                            <template slot="title">
                                <img class="logo-img" src="@/assets/exhome/xxzxH.png" alt="">
                                <span>学习中心</span>
                            </template>
                            <el-menu-item-group>
                                <el-menu-item index="10-1">分类</el-menu-item>
                                <el-menu-item index="10-2">学习资料</el-menu-item>
                            </el-menu-item-group>
                        </el-submenu>
                    </el-menu>
                </el-aside>
                <el-main  class="content" @scroll="syncContentScroll">
                    <!-- 标签页 -->
                    <div class="tab">
                        <PathHistory />
                    </div>
                    <router-view></router-view>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
    
<script>
import PathHistory from '@/components/PathHistory'
 
export default {
    components:{
        PathHistory
    },
    data() {
        return {
            activeIndex: sessionStorage.getItem('menu') || '1',
            userInfo:JSON.parse(localStorage.getItem('userInfo')) || {},

            isAdmin:JSON.parse(localStorage.getItem('userInfo')).is_admin || 0,//是否是专家
        }
    },
    methods: {
        handleSelect(key) {
            if(key=='1'){
                if( this.$route.path != "/address" ){
                    this.$router.push('/address')
                }
            }else if(key=='2'){
                if( this.$route.path != "/position" ){
                    this.$router.push('/position')
                }
            }else if(key=='3-1'){
                if( this.$route.path != "/todayWork" ){
                    this.$router.push('/todayWork')
                }
            }else if(key=='3-2'){
                if( this.$route.path != "/workbench" ){
                    this.$router.push('/workbench')
                }
            }else if(key=='5'){
                if( this.$route.path != "/expertWorkbench" ){
                    this.$router.push('/expertWorkbench')
                }
            }else if(key=='4'){
                if( this.$route.path != "/learning" ){
                    this.$router.push('/learning')
                }
            }

            this.activeIndex = key
            sessionStorage.setItem('menu',key)
        },
        handleSelectExport(key) {
            if(key=='1'){
                if( this.$route.path != "/index" ){
                    this.$router.push('/index')
                }
            }else if(key=='2'){
                if( this.$route.path != "/user_management" ){
                    this.$router.push('/user_management')
                }
            }else if(key=='3'){
                if( this.$route.path != "/dept" ){
                    this.$router.push('/dept')
                }
            }else if(key=='4'){
                if( this.$route.path != "/job" ){
                    this.$router.push('/job')
                }
            }else if(key=='5'){
                if( this.$route.path != "/work_content" ){
                    this.$router.push('/work_content')
                }
            }else if(key=='6-1'){
                if( this.$route.path != "/risk" ){
                    this.$router.push('/risk')
                }
            }else if(key=='6-2'){
                if( this.$route.path != "/method_type" ){
                    this.$router.push('/method_type')
                }
            }else if(key=='6-3'){
                if( this.$route.path != "/method" ){
                    this.$router.push('/method')
                }
            }else if(key=='7'){
                if( this.$route.path != "/risk_warning" ){
                    this.$router.push('/risk_warning')
                }
            }else if(key=='8'){
                if( this.$route.path != "/important_information" ){
                    this.$router.push('/important_information')
                }
            }else if(key=='9'){
                if( this.$route.path != "/today_work" ){
                    this.$router.push('/today_work')
                }
            }else if(key=='10-1'){
                if( this.$route.path != "/learning_center_type" ){
                    this.$router.push('/learning_center_type')
                }
            }else if(key=='10-2'){
                if( this.$route.path != "/learning_center_title" ){
                    this.$router.push('/learning_center_title')
                }
            }


            this.activeIndex = key
            sessionStorage.setItem('menu',key)
        },
        syncMenuScroll(event) {
            const content = this.$el.querySelector('.content');
            content.scrollTop = event.target.scrollTop;
        },
        syncContentScroll(event) {
            const menu = this.$el.querySelector('.menu');
            menu.scrollTop = event.target.scrollTop;
        },
        handleCommand(command) {
            if(command=='logOut'){
                this.LogOut()
            }else if(command=='Info'){
                this.nextInfo()
            }
        },
        nextInfo(){
            this.activeIndex = ''
            sessionStorage.setItem('menu','')
            this.$router.push('/userInfo')
        },
        // 退出登录
        LogOut(){
            localStorage.removeItem("userInfo");
            localStorage.removeItem("isLogin");
            sessionStorage.removeItem('menu')
            this.isShowUser=false
            this.$message({
                type:'success',
                message:'退出登录成功'
            })
            this.$router.push('/login')
        },
    },
    mounted() {
        this.activeIndex = sessionStorage.getItem('menu') || '1'
        // 页面刷新时重置历史记录
        this.$store.commit('RESET_HISTORY', {
            path: this.$route.fullPath,
            name: this.$route.name || '当前页面',
        })
    },
    beforeDestroy() {

    },
}
</script>
    
<style style lang="scss" scoped>
.el-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 0;
    z-index: 999;
}

.el-aside{
    height: 92vh;
    background: #FFFFFF;
    border-radius: 0px 0px 0px 0px;
    font-size: 16px;
    color: #666666;
    padding-top: 68px;

    width: 258px !important;
    box-sizing: content-box;
    color: #999999;
}


.logo-img{
    width: 20px;
    height: 20px;
    margin-right: 16px;
}
.el-menu{
    border: 0;
    // height: 700px;

    .el-menu-item{
        // margin-bottom: 10px;
        height: 68px;
        width: 240px;
        line-height: 68px;
        font-size: 16px;
    }
}

:deep(.el-menu){
    .el-submenu__title{
        // margin-bottom: 10px;
        height: 68px;
        width: 240px;
        line-height: 68px;
        font-size: 16px;
    }

    .el-menu-item-group__title{
        padding: 0px;
    }
}

.el-menu-item.is-active {
    width: 240px;
    height: 68px;
    background: #F2F6FF;
    color: #0277FD;
    border-right: 4px solid #0277FD;
}

.ziti{
    font-size: 16px !important;
    position: relative;
    .dian{
        width: 10px;
        height: 10px;
        display: inline-block;
        border-radius: 5px;
        background: #FE3300;
        // margin-left: 10px;
        position: absolute;
        top: -5px;
        right: -15px;
    }
}

.el-submenu__title{
    font-size: 16px !important;
}

// .menu {
//     width: 258px !important;
// }

.menu, .content {
  overflow-y: auto;
//   height: 800px; /* 根据需要调整高度 */
}

.tab{
    height: 48px;
    background: #FFFFFF;
}

.content{
    height: 90vh;
    margin: 68px 0px 24px;
    padding: 0px;
}

:deep(.el-badge){
    .el-badge__content.is-fixed{
        top: 14px;
        right: 0px
    }
}

.header-top {
    height: 68px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 80px;
    border-bottom: 1px solid #eeeeee;
    z-index: 9999;
    background: #FFFFFF;
    .header-top-logo {
        padding: 25px 0;
        display: flex;
        align-items: center;
        .logoImg{
            width: 42px;
            height: 42px;
        }

        .titleLogo{
            width: 266px;
            height: 24px;
            margin-left: 8px;
        }
    }

  .header-top-nav {
      display: flex;

      .kaitong{
          width: 100px;
          height: 38px;
          background: #EDF6FF;
          border-radius: 8px 8px 8px 8px;
          border: 0;
          font-size: 16px;
          color: #0073F5;

          margin-right: 18px;
      }
      .user{
        display: flex;
        align-items: center;
      .el-avatar{
          width: 36px;
          height: 36px;
          margin-right: 8px;
      }
      span{
          font-size: 16px;
          color: #666666;
      }
    }
  }
}

.kaifa{
    width: 100%;
    margin-top: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.shoucang{
  background: rgba(6,79,175,0.16);
  padding: 10PX 14PX;
  color: #fff;
  display: flex;
  color: #064FAF;
  margin-left: 12PX;
  margin-right: 12PX;
}
</style>